import { track } from '.';

export default function onClickDocsLink(docLink: string) {
  track('DOCSLINK.LINK_CLICKED', { link: docLink });
}
